export const injectedEnvironment: Record<string, string> = {
  REACT_APP_BACKEND_BASE_URL: "https://fe5ogrs9nh.execute-api.eu-central-1.amazonaws.com/prod",
};
